var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      [
        _c("label", { staticClass: "contactum-label" }, [
          _vm._v("Product Display Type")
        ]),
        _vm._v(" "),
        _c(
          "el-radio-group",
          {
            model: {
              value: _vm.select_type,
              callback: function($$v) {
                _vm.select_type = $$v
              },
              expression: "select_type"
            }
          },
          [
            _c("el-radio-button", { attrs: { label: "checkbox" } }),
            _vm._v(" "),
            _c("el-radio-button", { attrs: { label: "radio" } }),
            _vm._v(" "),
            _c("el-radio-button", { attrs: { label: "select" } })
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", [
      _c(
        "ul",
        {
          staticStyle: {
            display: "flex",
            "justify-content": "space-between",
            "margin-top": "10px"
          }
        },
        [
          _c("li", [_vm._v(_vm._s("Payment Items"))]),
          _vm._v(" "),
          _c(
            "li",
            [
              _c(
                "el-checkbox",
                {
                  attrs: { label: _vm.photo_value },
                  model: {
                    value: _vm.editfield.photo_value,
                    callback: function($$v) {
                      _vm.$set(_vm.editfield, "photo_value", $$v)
                    },
                    expression: "editfield.photo_value"
                  }
                },
                [_vm._v(" " + _vm._s("Photo") + " ")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "ul",
        {
          key: _vm.select_type,
          class: ["field-options", "option-field-swapper"]
        },
        _vm._l(_vm.options, function(option, index) {
          return _c(
            "li",
            {
              key: index,
              staticClass: "option-field-option",
              staticStyle: { display: "flex" }
            },
            [
              _c(
                "div",
                { staticClass: "selector" },
                [
                  _vm.select_type == "radio" || _vm.select_type == "select"
                    ? [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.selectedSingle,
                              expression: "selectedSingle"
                            }
                          ],
                          attrs: { type: "radio" },
                          domProps: {
                            value: option.name,
                            checked: _vm._q(_vm.selectedSingle, option.name)
                          },
                          on: {
                            change: function($event) {
                              _vm.selectedSingle = option.name
                            }
                          }
                        })
                      ]
                    : _vm.select_type == "checkbox"
                    ? [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.selectedMultiple,
                              expression: "selectedMultiple"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            value: option.name,
                            checked: Array.isArray(_vm.selectedMultiple)
                              ? _vm._i(_vm.selectedMultiple, option.name) > -1
                              : _vm.selectedMultiple
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.selectedMultiple,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = option.name,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.selectedMultiple = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.selectedMultiple = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.selectedMultiple = $$c
                              }
                            }
                          }
                        })
                      ]
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _vm._m(0, true),
              _vm._v(" "),
              _vm.editfield.photo_value == true
                ? _c("div", [
                    _c("div", { staticClass: "ff_photo_card" }, [
                      _c("div", { staticClass: "wpf_photo_holder" }, [
                        option.photo
                          ? _c("img", {
                              staticStyle: { "max-width": "100%" },
                              attrs: { src: option.photo, width: "50px" }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "photo_widget_btn" }, [
                          _c("i", {
                            staticClass: "el-icon-upload",
                            on: {
                              click: function($event) {
                                return _vm.initUploader(option)
                              }
                            }
                          }),
                          _vm._v(" "),
                          option.photo
                            ? _c("i", {
                                staticClass: "el-icon-delete",
                                on: {
                                  click: function($event) {
                                    option.photo = ""
                                  }
                                }
                              })
                            : _vm._e()
                        ])
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("el-input", {
                    model: {
                      value: option.name,
                      callback: function($$v) {
                        _vm.$set(option, "name", $$v)
                      },
                      expression: "option.name"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("el-input-number", {
                    model: {
                      value: option.price,
                      callback: function($$v) {
                        _vm.$set(option, "price", $$v)
                      },
                      expression: "option.price"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("i", {
                staticClass: "el-icon-circle-plus-outline",
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.add_option($event)
                  }
                }
              }),
              _vm._v(" "),
              _vm.options.length > 1
                ? _c("i", {
                    staticClass: "el-icon-remove-outline",
                    on: {
                      click: function($event) {
                        return _vm.delete_option(index)
                      }
                    }
                  })
                : _vm._e()
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "el-button",
            {
              attrs: { type: "danger" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.clear_selection($event)
                }
              }
            },
            [_vm._v(_vm._s("Clear Selection") + " ")]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sort-handler" }, [
      _c("i", { staticClass: "el-icon-s-fold" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }